<template>
	<tr @dblclick="onEditRow(item.id)" class="tableTr" :key="item.id">
		<td width="160">{{ item['create_at'] }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_created_by']}">{{ item['created_by'] }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_status']}">{{ item.status }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_date_start']}">{{ item['date_start'] }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_date_end']}">{{ item['date_end'] }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_contract_type']}">{{ item['contract_type'] }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
		<td width="160" :class="{'tdGreen': checkClasses['filter_file_name']}">{{ item['file_name'] }}</td>
		<td width="120">
			<div class="btnGroups">
				<button :class="{'hideFile': isHideFile}" type="button" @click="previewAction(item.file)">
					<svg-sprite height="20" width="20" icon-id="eye"></svg-sprite>
				</button>
				<button :class="{'hideFile': isHideFile}" type="button" @click="onDownload(item.file)">
					<svg-sprite height="20" width="20" icon-id="icon_download"></svg-sprite>
				</button>
				<button type="button" @click="onDeleteItem(item.id)">
					<svg-sprite height="20" width="20" icon-id="deleteItem"></svg-sprite>
				</button>
			</div>
		</td>
	</tr>
</template>

<script>
// services
import { getAppUrl } from "@/services";

export default {
	name: "TableTr",
	props: {
		checkClasses: Object,
		item: Object,
		isHideFile: Boolean
	},
	methods: {
		onEditRow(id) {
			this.$emit('updateEditRow', id);
		},
		previewAction(file) {
			this.$emit('updatePreviewAction', file);
		},
		onDownload(file) {
			this.$emit('updateDownload', getAppUrl + file);
		},
		onDeleteItem(id) {
			this.$emit('updateDeleteItem', id);
		}

	}
};
</script>

<style scoped lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
